import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { bbox as bboxStrategy } from 'ol/loadingstrategy';
import Circle from 'ol/style/Circle';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Icon from 'ol/style/Icon.js';

// private functions

// exported - public functions
export function getJsonSource(layername) {
    const vectorSource= new VectorSource({
        format: new GeoJSON(),
        url: function (extent) {
            return (
            `/geoserver/vx3dproject/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=${layername}&outputFormat=application%2Fjson&srsname=EPSG:900913&` +
                'bbox=' +
                extent.join(',') +
                ',EPSG:900913' 
            );
        },
        strategy: bboxStrategy,
    });
    return vectorSource;
}

export function getJsonSourceFiltered(layername, filter = '') {
    const vectorSource = new VectorSource({
        format: new GeoJSON(),
        url: function (extent) {
            return (
                `/geoserver/vx3dproject/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=${layername}&outputFormat=application%2Fjson&srsname=EPSG:900913&` +
                filter
            );
        },
        strategy: bboxStrategy,
    });
    return vectorSource;
}
export function getCircleStyle(radius, circlecolor) {
    // Create a circle style
    const circleStyle = new Style({
        image: new Circle({
            radius: radius,
            fill: new Fill({ color: circlecolor }),  // Optional: fill color
            stroke: new Stroke({ color: 'gray', width: 1 }), // Optional: stroke color and width
        }),
    });
    return circleStyle;
}
export function getIconStyle(iconurl, size) {

    const iconStyle = new Style({
        image: new Icon({
            //src: '/images/img-markers/peak.png',
            //width: 30,
            //height: 30
            src: iconurl,
            width: size,
            height: size,
        }),
    });
    return iconStyle;
}